import React from 'react';
import { Box, Typography } from '@mui/material';

export default function SectionHeader({ overline, title, subtitle, align = 'center', maxWidth = 640 }) {
  return (
    <Box
      sx={{
        textAlign: align,
        mb: { xs: 4, md: 6 },
        maxWidth: align === 'center' ? maxWidth : 'none',
        mx: align === 'center' ? 'auto' : 0,
        width: '100%',
        px: align === 'center' ? { xs: 0.5, sm: 0 } : 0,
      }}
    >
      {overline && (
        <Typography variant="overline" color="primary" sx={{ display: 'block', mb: 1.5 }}>
          {overline}
        </Typography>
      )}
      <Typography variant="h2" sx={{ mb: subtitle ? 2 : 0, color: 'text.primary' }}>
        {title}
      </Typography>
      {subtitle && (
        <Typography variant="body1" color="text.secondary" sx={{ lineHeight: 1.7 }}>
          {subtitle}
        </Typography>
      )}
    </Box>
  );
}